module.exports = __webpack_public_path__ + "img/copy-link.46d9a61c.svg";